import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { comicCategories } from "@/mocks/comicData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location]);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1440px] mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2.5 whitespace-nowrap cursor-pointer"
          >
            <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-read-line text-lg text-white"></i>
            </span>
            <span className="text-lg font-bold text-foreground-950 font-heading tracking-tight">
              虚空韩漫网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === "/"
                  ? "bg-primary-50 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              首页
            </Link>

            <div
              className="relative"
              onMouseEnter={() => setCategoryOpen(true)}
              onMouseLeave={() => setCategoryOpen(false)}
            >
              <button
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-1.5 whitespace-nowrap cursor-pointer ${
                  location.pathname.startsWith("/category")
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                分类
                <i
                  className={`ri-arrow-down-s-line text-sm transition-transform ${
                    categoryOpen ? "rotate-180" : ""
                  }`}
                ></i>
              </button>
              {categoryOpen && (
                <div className="absolute top-full left-0 mt-1 w-44 bg-background-50 rounded-xl border border-background-200 shadow-lg py-2 z-50">
                  {comicCategories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={cat.slug === "all" ? "/category/all" : `/category/${cat.slug}`}
                      className="flex items-center gap-2.5 px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <i className={`${cat.icon} text-base w-5 h-5 flex items-center justify-center`}></i>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === "/about"
                  ? "bg-primary-50 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 space-y-1">
            <Link
              to="/"
              className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              首页
            </Link>
            <div className="border-t border-background-100 my-1"></div>
            <p className="px-4 py-2 text-xs font-medium text-foreground-500 uppercase tracking-wider">
              漫画分类
            </p>
            {comicCategories.map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === "all" ? "/category/all" : `/category/${cat.slug}`}
                className="flex items-center gap-2.5 px-4 py-2.5 rounded-lg text-sm text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className={`${cat.icon} text-base w-5 h-5 flex items-center justify-center`}></i>
                {cat.name}
              </Link>
            ))}
            <div className="border-t border-background-100 my-1"></div>
            <Link
              to="/about"
              className="block px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}